import React from 'react';
import { ModalCard } from 'components/cards/ModalCard';
import { Grid } from 'components/layout/Grid';
import { Brikk } from 'components/Brikk';
import { Text } from 'components/typography/Text';
import { UserDetails } from 'components/user-components/UserDetails';
import { Profile } from 'components/user-components/Profile';
import { useUpdateUserSettings } from 'services/user/settings';
import { useRedirect } from 'utils/redirect';
import { NextStep } from 'components/form-elements/buttons/NextStep';
import { useTenantId } from 'services/user/tenant/hook';
import styles from './styles.module.scss';

export const CheckYourInfo = () => {
  const { updateUserSettings } = useUpdateUserSettings();
  const { tenantId } = useTenantId();

  const { onRedirect } = useRedirect();

  const onCompleteOnboarding = () => {
    updateUserSettings({ onboardingPassed: true });
    onRedirect(`/${tenantId}`);
  };

  return (
    <ModalCard className={styles.card}>
      <Grid
        paddingTop
        brikkLayout
      >
        <Grid.Column>
          <Brikk.Heading 
            main 
            heading="onboardingYourInfoTitle"
          >
            <Text
              size={16}
              intl="onboardingYourInfoDescription"
            />
          </Brikk.Heading>
        </Grid.Column>

        <Grid.Column>
          <UserDetails />
        </Grid.Column>

        <Grid.Column>
          <Profile />
        </Grid.Column>

        <NextStep onClick={onCompleteOnboarding} />
      </Grid>
    </ModalCard>
  );

};
